import React, { useEffect, useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';


const initialValues = {
    title: ''
};

const validationSchema = Yup.object({
    title: Yup.string()
        .required('این فیلد الزامی است..')
        .min(2, "تعداد حروف کم است  ")
        .max(50, "تعداد حروف زیاد است "),
});


const Update = () => {

    const { readDataByFilter } = useEntityCrud('Question/get');
    const { updateDate } = useEntityCrud("Question/Update")

    const { id , item } = useParams();
    const navigate = useNavigate();

console.log(useParams());
    const { readData: readDataOpinionFactor } = useEntityCrud('OpinionFactor/getAll')
    const [opinionFactorList, setOpinionFactorList] = useState([]);
    useEffect(() => {
        readDataOpinionFactor().then(res => {
            setOpinionFactorList(res.data.result.map(item => ({ value: item.id, label: item.title, isActive: item.status })))
        });
    }, [])

     useEffect((e) => {
         
        const postedData = {
            "questionId": id,
        };

        readDataByFilter(postedData).then(({ data }) => {
             
            if (data.status) {
                formik.setValues({
                    ...data.result,
                    factorId: { value: data.result.factorId, label: opinionFactorList?.find(item => item.value === data.result.factorId)?.label }
                });

            }
            ;

        });
    }, [opinionFactorList]);

    const onSubmit = (values) => {
         
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            "title": values.title,
            "status": true,
            "factorId": values.factorId.value,
            "opinionId": item,
        };
        updateDate({ ...postedData, id }).then(({ data }) => {
             
            if (data.status) {
                toast.success('به روزرسانی پرسش با موفقیت انجام شد');
                return navigate(`/surveyQuestion/${item}`);
            } else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش پرسش</div>
                <a className="backIconLink" onClick={() => navigate(-1)}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik}
                    opinionFactorList={opinionFactorList} setOpinionFactorList={setOpinionFactorList} />
            </div>
        </div>
    );
}

export default Update;